import React from 'react';
import '../css/footer.css';
import { navLinks, socialLinks } from '../data';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <p>CopyRight &copy; {year} Syed Ghyas Ali. All rights reserved.</p>
        <div className="footer-links">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </div>
        <div className="social-links">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              title={social.name}
              aria-label={`Visit my ${social.name} profile`}
            >
              <img src={social.icon} alt={social.name} />
            </a>
          ))}
        </div>
        <div className="footer-bottom">
          <p>Built with ❤️ using React.js</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;